export type Themes = 'light' | 'dark';
const ARBOR_THEME = 'arborTheme';
export const getCurrentTheme = () => {
  const currentTheme = window.localStorage.getItem(ARBOR_THEME) as Themes;
  return currentTheme == null ? 'light' : currentTheme;
};
export const getNextTheme = () => {
  const currentTheme = getCurrentTheme();
  const nextTheme = currentTheme === 'light' ? 'dark' : 'light';
  return nextTheme;
};
export const switchTheme = () => {
  window.localStorage.setItem(ARBOR_THEME, getNextTheme());
  window.location.reload();
};
